var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobPolyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8507 1.45807C11.4816 2.55094 10.332 4.39594 8.28287 5.579C6.23375 6.76206 4.06111 6.83518 3.43014 5.74232C2.79918 4.64945 3.94882 2.80445 5.99794 1.62139C8.04706 0.438328 10.2197 0.36521 10.8507 1.45807Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28493 7.7182C3.54686 7.7182 4.56986 9.63632 4.56986 12.0024C4.56986 14.3686 3.54686 16.2867 2.28493 16.2867C1.023 16.2867 1.03427e-07 14.3686 0 12.0024C-1.03426e-07 9.63632 1.023 7.7182 2.28493 7.7182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43426 18.2726C4.06523 17.1798 6.23787 17.2529 8.28699 18.4359C10.3361 19.619 11.4858 21.464 10.8548 22.5569C10.2238 23.6497 8.05118 23.5766 6.00206 22.3936C3.95294 21.2105 2.8033 19.3655 3.43426 18.2726Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1493 22.5545C12.5184 21.4616 13.668 19.6166 15.7171 18.4336C17.7663 17.2505 19.9389 17.1774 20.5699 18.2702C21.2008 19.3631 20.0512 21.2081 18.0021 22.3912C15.9529 23.5742 13.7803 23.6474 13.1493 22.5545Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7151 16.2819C20.4531 16.2819 19.4301 14.3638 19.4301 11.9977C19.4301 9.63156 20.4531 7.71344 21.7151 7.71344C22.977 7.71344 24 9.63156 24 11.9977C24 14.3638 22.977 16.2819 21.7151 16.2819Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5657 5.72035C19.9348 6.81321 17.7621 6.74009 15.713 5.55703C13.6639 4.37397 12.5142 2.52897 13.1452 1.4361C13.7762 0.343239 15.9488 0.416357 17.9979 1.59942C20.0471 2.78248 21.1967 4.62748 20.5657 5.72035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobPolyicon);
export default __webpack_public_path__ + "static/media/mobPolyicon.119359ff8b0615fed6edd1125328e719.svg";
export { ForwardRef as ReactComponent };